class StickyHeader extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.header = document.querySelector('.section-header');
        this.mobileHeader = document.querySelector('.header__heading-wrapper-mobile');

        const stickyAttribute = this.getAttribute('data-sticky-type');
        this.headerIsAlwaysSticky =
            stickyAttribute === 'always' ||
            stickyAttribute === 'reduce-logo-size' ||
            stickyAttribute === 'always-bottom';
        this.headerBounds = {};

        this.storedHeaderHeight = null;
        this.storedMobileHeaderHeight = null;
        this.storedBottomHeaderHeight = null;

        this.initialHeaderOffsetHeight = null;
        this.initialHeaderOffsetHeightMobile = null;
        this.initialHeaderBottomHeight = null;
        const stickyHeaderHeightAttribute = this.getAttribute('data-css-property');
        if (stickyHeaderHeightAttribute) {
            try {
                const { lg, m, bm } = JSON.parse(stickyHeaderHeightAttribute);
                this.storedHeaderHeight = lg;
                this.storedMobileHeaderHeight = m;
                this.storedBottomHeaderHeight = bm;
            } catch (e) {}
        }

        this.setHeaderHeight();

        window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

        if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
        } else this.header.classList.remove('shopify-section-header-sticky');

        this.currentScrollTop = 0;
        this.preventReveal = false;
        this.predictiveSearch = this.querySelector('predictive-search');

        this.onScrollHandler = this.onScroll.bind(this);
        this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

        this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.addEventListener('scroll', this.onScrollHandler, false);

        this.createObserver();
        window.addEventListener('load', this.onScrollHandler, false);
    }

    setHeaderHeight() {
        // When we render, we access offsetHeight and store it
        if (window.innerWidth >= 990 && !this.initialHeaderOffsetHeight)
            this.initialHeaderOffsetHeight = this.header.offsetHeight;
        if (window.innerWidth < 990 && !this.initialHeaderOffsetHeightMobile)
            this.initialHeaderOffsetHeightMobile = this.mobileHeader.offsetHeight;
        if (window.innerWidth < 990 && !this.initialHeaderBottomHeight)
            this.initialHeaderBottomHeight = this.offsetHeight;

        // Before set the css properties, we check if there are differences
        if (window.innerWidth >= 990 && this.storedHeaderHeight !== `${this.initialHeaderOffsetHeight}px`)
            document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        if (window.innerWidth < 990 && this.storedMobileHeaderHeight !== `${this.initialHeaderOffsetHeightMobile}`)
            document.documentElement.style.setProperty('--header-height-mobile', `${this.mobileHeader.offsetHeight}px`);
        if (window.innerWidth < 990 && this.storedBottomHeaderHeight !== `${this.initialHeaderBottomHeight}px`)
            document.documentElement.style.setProperty('--bottom-header-height', `${this.offsetHeight}px`);
    }

    disconnectedCallback() {
        this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
        let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
        });

        observer.observe(this.header);
    }

    onScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        let scrollPastToHeaderLimit = this.headerBounds.bottom;
        if (window.innerWidth <= 990) {
            scrollPastToHeaderLimit = scrollPastToHeaderLimit / 2;
        }
        if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

        if (scrollTop > this.currentScrollTop && scrollTop > scrollPastToHeaderLimit) {
            this.header.classList.add('scrolled-past-header');

            if (this.preventHide) return;
            requestAnimationFrame(this.hide.bind(this));
            this.setHeaderHeight();
        } else if (scrollTop < this.currentScrollTop && scrollTop > scrollPastToHeaderLimit) {
            this.header.classList.add('scrolled-past-header');

            if (!this.preventReveal) {
                requestAnimationFrame(this.reveal.bind(this));
            } else {
                window.clearTimeout(this.isScrolling);

                this.isScrolling = setTimeout(() => {
                    this.preventReveal = false;
                }, 66);

                requestAnimationFrame(this.hide.bind(this));
            }
        } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
        }

        this.currentScrollTop = scrollTop;
    }

    hide() {
        if (this.headerIsAlwaysSticky) return;
        this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
        this.closeMenuDisclosure();
        this.closeSearchModal();
    }

    reveal() {
        if (this.headerIsAlwaysSticky) return;
        this.header.classList.add('shopify-section-header-sticky', 'animate');
        this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
        if (this.headerIsAlwaysSticky) return;
        this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
        this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
        this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
        this.searchModal = this.searchModal || this.header.querySelector('details-modal');
        if (this.searchModal) this.searchModal.close(false);
    }
}

customElements.define('sticky-header', StickyHeader);
